// The code from a verify-email link, taken off the address bar as the app starts.
//
// New links carry it after a # (gympods.com/verify-email#<code>), so it is never sent to
// any server; links already in inboxes carry it in the path (/verify-email/<code>). Either
// way the address becomes plain /verify-email before anything else reads it.
//
// main.js imports this module FIRST: the router reads the address when its module loads
// and writes it back on the first navigation, and analytics boots soon after, so the
// address must be cleaned before either. VerifyEmail.vue reads the code with
// verifyLinkCode(), and calls captureVerifyLinkCode() again if a link is opened in a tab
// already on /verify-email (a # change doesn't reload the page).
let code = null;

export function captureVerifyLinkCode() {
  if (typeof window === 'undefined' || window.__PRERENDER__) return;
  try {
    const { pathname, hash } = window.location;
    const match = pathname.match(/^\/verify-email(?:\/([^/]+))?\/?$/);
    if (!match) return;
    const fromHash = hash.length > 1 ? decodeURIComponent(hash.slice(1)) : '';
    const fromPath = match[1] ? decodeURIComponent(match[1]) : '';
    code = fromHash || fromPath || null;
    if (code) window.history.replaceState(window.history.state, '', '/verify-email');
  } catch (e) { /* a malformed address: leave it, and the page shows the expired-link view */ }
  return code;
}

captureVerifyLinkCode();

export function verifyLinkCode() {
  return code;
}
